import React from "react";
import styles from "./Description.module.css";

function Description() {
  return (
    <div className={styles.descriptionWrapper}>
      <h1>
        Generate <span>Beautiful</span> code snapshots in no Time
      </h1>
    </div>
  );
}

export default Description;
